export default function getLinkedInIdFromCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined

  const value = document.cookie
    .split('; ')
    .find((row) => row.startsWith('li_fat_id='))
    ?.slice('li_fat_id='.length)

  if (!value) return undefined

  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}
